exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".adjust-width > tr > th {\n  width: 11% !important; }\n\n.adjust-width > tr > th:first-child {\n  width: 25% !important; }\n\n.adjust-width > tr > td {\n  width: 11% !important; }\n\n.adjust-width > tr > td:first-child {\n  width: 25% !important; }\n\ndiv.full-width {\n  width: 100%; }\n\ntable.full-width {\n  width: 100%;\n  border-collapse: collapse; }\n\n.top-spacing {\n  padding-top: 1rem; }\n\n.header-color-bar {\n  background-color: #e1e6ef !important; }\n\n.even-row {\n  background-color: #f5f7f9 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/market-cap-rank-pe/market-cap-rank-pe.component.scss
// module id = ../../../../../src/app/market-level/market-cap-rank-pe/market-cap-rank-pe.component.scss
// module chunks = main